export default function(H, lang, translations) {
    switch (lang) {
        case 'it':
            H.setOptions({
                time: {
                    timezone: 'Europe/Rome'
                },
                lang: {
                    contextButtonTitle: translations.contextButtonTitle,
                    downloadCSV: translations.downloadCSV,
                    downloadJPEG: translations.downloadJPEG,
                    downloadPDF: translations.downloadPDF,
                    downloadPNG: translations.downloadPNG,
                    downloadSVG: translations.downloadSVG,
                    downloadXLS: translations.downloadXLS,
                    exitFullscreen: translations.exitFullscreen,
                    hideData: translations.hideData,
                    loading: translations.loading,
                    months: translations.months,
                    noData: translations.noData,
                    printChart: translations.printChart,
                    rangeSelectorFrom: translations.rangeSelectorFrom,
                    rangeSelectorTo: translations.rangeSelectorTo,
                    resetZoom: translations.resetZoom,
                    resetZoomTitle: translations.resetZoomTitle,
                    shortMonths: translations.shortMonths,
                    viewData: translations.viewData,
                    viewFullscreen: translations.viewFullscreen,
                    weekdays: translations.weekdays,
                }
            });            
            break;
    
        case 'es':
            H.setOptions({
                time: {
                    timezone: 'Europe/Rome'
                },
                lang: {
                    contextButtonTitle: translations.contextButtonTitle,
                    downloadCSV: translations.downloadCSV,
                    downloadJPEG: translations.downloadJPEG,
                    downloadPDF: translations.downloadPDF,
                    downloadPNG: translations.downloadPNG,
                    downloadSVG: translations.downloadSVG,
                    downloadXLS: translations.downloadXLS,
                    exitFullscreen: translations.exitFullscreen,
                    hideData: translations.hideData,
                    loading: translations.loading,
                    months: translations.months,
                    noData: translations.noData,
                    printChart: translations.printChart,
                    rangeSelectorFrom: translations.rangeSelectorFrom,
                    rangeSelectorTo: translations.rangeSelectorTo,
                    resetZoom: translations.resetZoom,
                    resetZoomTitle: translations.resetZoomTitle,
                    shortMonths: translations.shortMonths,
                    viewData: translations.viewData,
                    viewFullscreen: translations.viewFullscreen,
                    weekdays: translations.weekdays,
                }
            });            
            break;       

        default:
            H.setOptions({
                time: {
                    timezone: 'Europe/Rome'
                }
            });  
            break;
    }

}